import { useState } from "react";

export const useLocalStorage = (itemKey, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(itemKey);
      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(itemKey, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    try {
      window.localStorage.setItem(itemKey, JSON.stringify(newValue));
      setStoredValue(newValue);
    } catch (err) {
      console.error(`failed to update local storage item (${itemKey})`, err);
    }
  };

  return [storedValue, setValue];
};
